import React, { useEffect } from 'react';
import '@uppy/core/dist/style.css';
import '@uppy/dashboard/dist/style.css';
import { Dashboard } from '@uppy/react';
import { Uppy } from '@uppy/core';

// components and helpers
// @ts-ignore
import { types } from '../../WorkspaceActions';
import { useDispatch, useSelector } from 'react-redux';

// mui
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
import { useTheme } from '@mui/material/styles';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';

interface AssetUploadProps {
    setFileType: (type: string) => void;
    fileType: string;
    setExtension: (ext: string) => void;
    setFilesAdded: (files: any) => void;
}
const AssetUpload: React.FC<AssetUploadProps> = ({
    setFileType,
    fileType,
    setExtension,
    setFilesAdded,
}) => {
    const theme = useTheme();
    const dispatch = useDispatch();
    const caseConfig = useSelector(
        (state: any) => state.workspace['case-configuration']
    );
    const localeUpdates = {
        strings: {
            addMoreFiles: 'Add More Assets',
            addingMoreFiles: 'Adding More Assets',
            removeFile: 'Remove Asset',
            editFile: 'Edit Asset',
            finishEditingAsset: 'Finish editing asset',
            dropHint: 'Drop your assets here',
            editFileWithFilename: 'Edit asset %{file}',
            dropPasteFiles:
                'Add new cases to the workspace by dropping files here or %{browseFiles}',
            poweredBy: '',
        },
    };
    const allowedFileTypes = ['.xlsx'];
    const uppy = React.useMemo(() => {
        return new Uppy({
            restrictions: {
                maxNumberOfFiles: 1,
                minNumberOfFiles: 1,
                allowedFileTypes: allowedFileTypes,
                maxTotalFileSize: 500000,
            },
            locale: localeUpdates,
            allowMultipleUploadBatches: false,
            // @ts-ignore
            onBeforeFileAdded: (files) => {
                if (allowedFileTypes.includes(`.${files.extension}`)) {
                    return handleSetAddedFile(files);
                } else {
                    return;
                }
            },
        });
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [fileType]);

    uppy.on('file-removed', (file) => {
        setExtension('');
        setFilesAdded(null);
    });

    const handleSetAddedFile = (files) => {
        setExtension(files.extension);
        setFilesAdded(files);
    };

    useEffect(() => {
        return () => uppy.close();
    }, [uppy]);

    const handleFileType = (e) => {
        const type = e.target.value;
        let data = {};
        setFileType(type);
        if (type === 'CASE') {
            data = caseConfig;
        } else {
            return;
        }
        dispatch({
            type: types.SAVE_FILE_IMPORT_MAPPING_SUCCESS,
            payload: {
                data: {
                    mapping: data,
                },
                error: undefined,
            },
        });
    };

    return (
        <Grid container>
            <Grid item xs={12}>
                <Paper elevation={0} style={{ padding: 10, borderRadius: 15 }}>
                    <Grid container justifyContent={'center'} spacing={2}>
                        <Grid item xs={4}>
                            <FormControl fullWidth required>
                                <InputLabel id="demo-simple-select-label">
                                    Data Type
                                </InputLabel>
                                <Select
                                    labelId="demo-simple-select-label"
                                    id="demo-simple-select"
                                    value={fileType}
                                    label="Data Type"
                                    onChange={handleFileType}
                                >
                                    <MenuItem value={'CASE'}>Case</MenuItem>
                                </Select>
                            </FormControl>
                        </Grid>
                        {fileType && (
                            <Grid item xs={12}>
                                <Dashboard
                                    uppy={uppy}
                                    width={'100%'}
                                    height={300}
                                    showProgressDetails
                                    disableThumbnailGenerator
                                    theme={theme.palette.mode}
                                    hideUploadButton
                                />
                            </Grid>
                        )}
                    </Grid>
                </Paper>
            </Grid>
        </Grid>
    );
};

export default AssetUpload;
